import styled from 'styled-components/macro';
import { Label, BigLabel } from '../../../SubComponents/Text';
import { useContext } from 'react';
import { formatDuration } from '../../../Utils/utils';
import { colors } from '../../../Style/Theme';
import useGiftcardTracking from '../../../Hooks/use-giftcard-tracking';
import { giftcardState } from '../client-state/giftcard-state-context';
import useLocale from '../../../Hooks/use-locale';
import localizations from '../../../localizations';
import { giftcardReducerActionTypes } from '../../../redusers/giftcardReducer';
import useGiftcardShop from '../server-data/use-giftcard-shop';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const DurationColumn = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  background-color: ${colors.lightBlue};
  padding: 0 5px;
`;

const DurationNumber = styled(BigLabel)<{ selected: boolean; disabled?: boolean }>`
  color: ${(props) => (props.selected ? '#fff' : props.theme.textColor)};
  background-color: ${(props) =>
    props.selected ? props.theme.colors.primary : 'transparent'};
  min-width: 28px;
  height: 28px;
  line-height: 28px;
  text-align: center;
  margin: 7.5px 0;
  border-radius: 100px;
  padding: 0 10px;
  white-space: nowrap;
  cursor: ${(props) => (props.disabled ? 'default' : 'pointer')};
  opacity: ${(props) => (props.selected ? 1 : props.disabled ? 0.35 : 1)};

  :hover {
    color: ${(props) =>
      props.selected
        ? '#fff'
        : props.disabled
        ? props.theme.textColor
        : props.theme.highLightColor};
  }
`;

const DurationLabel = styled(Label)`
  white-space: nowrap;
  padding: 8px 6px;
`;

interface DumbDurationOptionProps {
  duration: number | string;
  price: string;
}

const DumbDurationOption = (props: DumbDurationOptionProps) => {
  const { data: shop } = useGiftcardShop();
  const { state, dispatch } = useContext(giftcardState);
  const track = useGiftcardTracking();
  const { languageAsEnum } = useLocale();
  const localization = localizations[languageAsEnum];

  const onClick = () => {
    dispatch({
      type: giftcardReducerActionTypes.UPDATE_DURATION,
      payload: props.duration,
    });
    track({ type: 'CHANGE_DURATION', duration: props.duration });
  };

  const labelProps = {
    onClick,
    fontSize: '1.2rem',
    textAlign: 'center',
    width: '100%',
    monospaced: true,
  };

  const handleKeyPress = (event: React.KeyboardEvent<HTMLLabelElement>) => {
    if (event.key === ' ' || event.key === 'Enter') onClick();
  };

  const selected = state.giftcard.duration === props.duration;

  const numberProps = {
    selected,
    onClick,
    onKeyPress: handleKeyPress,
    tabIndex: 0,
  };

  const hideDurations = shop?.configuration?.hideGiftCardDurations ?? false;

  return (
    <Container>
      <DurationColumn>
        <DurationNumber {...numberProps}>
          {hideDurations ? props.price : formatDuration(props.duration, { localization })}
        </DurationNumber>
      </DurationColumn>
      {shop?.configuration?.hideGiftCardDurations ? null : (
        /* @ts-expect-error */
        <DurationLabel {...labelProps}>{props.price}</DurationLabel>
      )}
    </Container>
  );
};

export default DumbDurationOption;
